let locationsData = [
 {
    id: 'jojos',
    // disabled: true, openingDate: "visit/call to order",
    label: "West Hollywood",
    className: 'night',
    address: ["8000 Sunset Blvd Suite B130", "West Hollywood 90046"],
    phone: "(323) 822-5555",
    phoneLink: "+13238225555",
    orderLink: "/westhollywood",
    hours: [
      { day: 'Mon-Sat', hours: '10am-10pm' },
      { day: 'Sunday', hours: '11am-10pm' },

    ]},


    // {
    //   id: 'taronnoho',
    //   label: "North Hollywood",
    //   disabled: true, openingDate: "online ordering coming soon",
    //   // special: "We Moved!",
    //   address: ["12901 Sherman Way, Ste D", "North Hollywood, CA 91605"],
    //   phone: "818-765-7722",
    //   phoneLink: "+18187657722",
    //   orderLink: "/melrose",
    //   // external: true,
    //   hours: [
    //     { day: 'Mon-Sat', hours: '7:30am-7pm' },
    //     { day: 'Sun', hours: '7:30am-4:30pm' },
  
    //   ]},
    //   {
    //     id: 'taronhollywood',
    //     disabled: true, openingDate: "online ordering coming soon",
    //     label: "Hollywood",
    //     className: 'night',
    //     address: ["4950 Hollywood Blvd", "Los Angeles, CA 90027"],
    //     phone: "323-663-4809",
    //     phoneLink: "+13236634809",
    //     orderLink: "/reseda",
    //     hours: [
    //       { day: 'Mon-Sat', hours: '7:30am-7pm' },
    //       { day: 'Sun', hours: '7:30am-4:30pm' },
  
    //     ]},
  
  ]

  export default locationsData